export const LS_KEY_USER: string = 'authUser';
export const LS_KEY_USERS: string = 'users';
export const LS_POPUPS: string = 'popups-displayed';
export const LS_SINGLE_POPUP: string = 'popup-single-closed';

export const LAYOUTS: { [key: string]: string } = {
  VERTICAL: 'vertical',
};

export const SIDEBAR_SIZE: { [key: string]: string } = {
  DEFAULT: 'lg',
  COMPACT: 'md',
  SMALL: 'sm',
};

export const TOP_BAR: { [key: string]: string } = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const LAYOUT_WIDTH: { [key: string]: string } = {
  FLUID: 'fluid',
};

export const SIDEBAR_COLOR: { [key: string]: string } = {
  LIGHT: 'light',
  DARK: 'dark',
  GRADIENT: 'gradient',
  GRADIENT2: 'gradient-2',
  GRADIENT3: 'gradient-3',
  GRADIENT4: 'gradient-4',
};

export const LAYOUT_THEME: { [key: string]: string } = {
  DEFAULT: 'default',
  MINIMAL: 'minimal',
};

export const SITE_THEME = {
  LIGHT: 'light',
  DARK: 'dark',
  BRAND: 'brand',
};

export const LAYOUT_POSITION = {
  FIXED: 'fixed',
  SCROLLABLE: 'scrollable',
};

export const PRELOADER = {
  ENABLE: 'enable',
  DISABLE: 'disable',
};

export const DIR = {
  LTR: 'ltr',
  RTL: 'rtl',
};

export const COLOR_SWATCHES = [
  ['#ffcdd2', '#ffe0b2', '#ffecb3', '#fff9c4'],
  ['#e1bee7', '#f8bbd0', '#ffccbc', '#f0f4c3'],
  ['#c5cae9', '#d1c4e9', '#b2dfdb', '#dcedc8'],
  ['#bbdefb', '#b3e5fc', '#b2ebf2', '#c8e6c9'],
  ['#f5f5f5', '#d7ccc8', '#cfd8dc', '#b0bec5'],
];

export const ReservedType = {
  MTR: 'meetingRoom',
  CAR: 'car',
};

export const ReserveMeetingRoomStatus = {
  RESERVED: 'Reserved',
  CANCEL: 'Cancel',
  FINISHED: 'Finished',
};

export const ReserveCarStatus = {
  WAITING: 'Waiting',
  CHF_APPROVED: 'ChiefApproved',
  ADM_APPROVED: 'AdminApproved',
  APPROVED: 'Approved',
  CANCEL: 'Cancel',
};

export const PopupMode = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};
export const ExternalType = {
  NONE: 'None',
  GOOGLEID: 'GoogleID',
  THAID: 'Thaid',
};
export const timeSlots: any[] = [
  {
    group: 0,
    startTimeValue: 0,
    start: '00:00',
    end: '00:30',
  },
  {
    group: 0,
    startTimeValue: 30,
    start: '00:30',
    end: '01:00',
  },
  {
    group: 0,
    startTimeValue: 100,
    start: '01:00',
    end: '01:30',
  },
  {
    group: 0,
    startTimeValue: 130,
    start: '01:30',
    end: '02:00',
  },
  {
    group: 0,
    startTimeValue: 200,
    start: '02:00',
    end: '02:30',
  },
  {
    group: 0,
    startTimeValue: 230,
    start: '02:30',
    end: '03:00',
  },
  {
    group: 0,
    startTimeValue: 300,
    start: '03:00',
    end: '03:30',
  },
  {
    group: 0,
    startTimeValue: 330,
    start: '03:30',
    end: '04:00',
  },
  {
    group: 0,
    startTimeValue: 400,
    start: '04:00',
    end: '04:30',
  },
  {
    group: 0,
    startTimeValue: 430,
    start: '04:30',
    end: '05:00',
  },
  {
    group: 0,
    startTimeValue: 500,
    start: '05:00',
    end: '05:30',
  },
  {
    group: 0,
    startTimeValue: 530,
    start: '05:30',
    end: '06:00',
  },
  {
    group: 0,
    startTimeValue: 600,
    start: '06:00',
    end: '06:30',
  },
  {
    group: 0,
    startTimeValue: 630,
    start: '06:30',
    end: '07:00',
  },
  {
    group: 0,
    startTimeValue: 700,
    start: '07:00',
    end: '07:30',
  },
  {
    group: 0,
    startTimeValue: 730,
    start: '07:30',
    end: '08:00',
  },
  {
    group: 1,
    startTimeValue: 800,
    start: '08:00',
    end: '09:00',
  },
  {
    group: 1,
    startTimeValue: 830,
    start: '08:30',
    end: '09:00',
  },
  {
    group: 2,
    startTimeValue: 900,
    start: '09:00',
    end: '09:30',
  },
  {
    group: 2,
    startTimeValue: 930,
    start: '09:30',
    end: '10:00',
  },
  {
    group: 3,
    startTimeValue: 1000,
    start: '10:00',
    end: '10:30',
  },
  {
    group: 3,
    startTimeValue: 1030,
    start: '10:30',
    end: '11:00',
  },
  {
    group: 4,
    startTimeValue: 1100,
    start: '11:00',
    end: '11:30',
  },
  {
    group: 4,
    startTimeValue: 1130,
    start: '11:30',
    end: '12:00',
  },
  {
    group: 5,
    startTimeValue: 1200,
    start: '12:00',
    end: '12:30',
  },
  {
    group: 5,
    startTimeValue: 1230,
    start: '12:30',
    end: '13:00',
  },
  {
    group: 6,
    startTimeValue: 1300,
    start: '13:00',
    end: '13:30',
  },
  {
    group: 6,
    startTimeValue: 1330,
    start: '13:30',
    end: '14:00',
  },
  {
    group: 7,
    startTimeValue: 1400,
    start: '14:00',
    end: '14:30',
  },
  {
    group: 7,
    startTimeValue: 1430,
    start: '14:30',
    end: '15:00',
  },
  {
    group: 8,
    startTimeValue: 1500,
    start: '15:00',
    end: '15:30',
  },
  {
    group: 8,
    startTimeValue: 1530,
    start: '15:30',
    end: '16:00',
  },
  {
    group: 9,
    startTimeValue: 1600,
    start: '16:00',
    end: '16:30',
  },
  {
    group: 9,
    startTimeValue: 1630,
    start: '16:30',
    end: '17:00',
  },
  {
    group: 10,
    startTimeValue: 1700,
    start: '17:00',
    end: '17:30',
  },
  {
    group: 10,
    startTimeValue: 1730,
    start: '17:30',
    end: '18:00',
  },
  {
    group: 0,
    startTimeValue: 1800,
    start: '18:00',
    end: '18:30',
  },
  {
    group: 0,
    startTimeValue: 1830,
    start: '18:30',
    end: '19:00',
  },
  {
    group: 0,
    startTimeValue: 1900,
    start: '19:00',
    end: '19:30',
  },
  {
    group: 0,
    startTimeValue: 1930,
    start: '19:30',
    end: '20:00',
  },
  {
    group: 0,
    startTimeValue: 2000,
    start: '20:00',
    end: '20:30',
  },
  {
    group: 0,
    startTimeValue: 2030,
    start: '20:30',
    end: '21:00',
  },
  {
    group: 0,
    startTimeValue: 2100,
    start: '21:00',
    end: '21:30',
  },
  {
    group: 0,
    startTimeValue: 2130,
    start: '21:30',
    end: '22:00',
  },
  {
    group: 0,
    startTimeValue: 2200,
    start: '22:00',
    end: '22:30',
  },
  {
    group: 0,
    startTimeValue: 2230,
    start: '22:30',
    end: '23:00',
  },
  {
    group: 0,
    startTimeValue: 2300,
    start: '23:00',
    end: '23:30',
  },
  {
    group: 99,
    startTimeValue: 2330,
    start: '23:30',
    end: '00:00',
  },
];
